import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import {
  ISignInRequestDto,
  postSignIn,
} from '@/shared/api/auth';
import { ApiError } from '@/shared/api/ApiError';
import i18n from '@/shared/i18n';
import { getRoutePath } from '@/shared/utils/routes';

export const useSignIn = () => {
  const navigate = useNavigate();

  const signInMutation = useMutation({
    mutationFn: async (vars: ISignInRequestDto) => {
      const response = await postSignIn(vars);

      if ((response as { unauthorized?: boolean } | undefined)?.unauthorized) {
        const invalidCredentials = i18n.t('common:errors.invalid_credentials');
        throw new ApiError(invalidCredentials, 401, {
          details: invalidCredentials,
          title: invalidCredentials,
        });
      }

      return response;
    },
  });

  const mutate = (data: ISignInRequestDto): void => {
    signInMutation.mutate(data, {
      onSuccess: (response) => {
        if (response.auth_token) {
          navigate(getRoutePath('AUTH', 'VERIFY_CODE'), {
            state: {
              token: response.auth_token,
              email: data.email,
            },
          });
        } else {
          navigate(getRoutePath('MAIN', 'INDEX'));
        }
      },
    });
  };

  return {
    ...signInMutation,
    mutate,
  };
};
